import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonComponent, ButtonType } from '@app/components/button';
import { SecondaryNavigationComponent } from '@app/components/secondary-navigation';
import { ViewAlign, ViewComponent, ViewJustify } from '@app/components/view';
import { Spacing } from '@app/shared/types';
import { TranslatePipe } from '@ngx-translate/core';
import { SaveChangesConfirmationComponent } from '../../shared/components/save-changes-confirmation/save-changes-confirmation.component';
import { TenantConfigurationService } from './tenant-configuration.service';

@Component({
  selector: 'app-tenant-configuration',
  standalone: true,
  imports: [
    RouterModule,
    SecondaryNavigationComponent,
    SaveChangesConfirmationComponent,
    ViewComponent,
    ButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './tenant-configuration.component.html',
})
export class TenantConfigurationComponent {
  tenantConfigurationService = inject(TenantConfigurationService);
  private readonly router = inject(Router);
  routeView = signal<string>('');

  ViewJustify = ViewJustify;
  ViewAlign = ViewAlign;
  Spacing = Spacing;
  ButtonType = ButtonType;

  links = [
    { route: '/tenant-configuration/general', label: 'General' },
    { route: '/tenant-configuration/features', label: 'Features' },
    { route: '/tenant-configuration/contracts', label: 'Contracts' },
    { route: '/tenant-configuration/advanced', label: 'Advanced' },
  ];

  onActivate() {
    const fullPath = this.router.url;
    this.routeView.set(fullPath);
  }

  handleAddNewTenantDialog() {
    this.tenantConfigurationService.toggleAddNewTenantDialog();
  }

  handleAddNewContractDialog() {
    this.tenantConfigurationService.toggleAddNewContractDialog();
  }
}
